//---------------------
//매매
//---------------------
const buyRouter = [
  // 직거래 랜딩
  {
    path: "/buy/direct",
    name: "buy-direct",
    component: () => import("../views/buy/BuyDirectView.vue"),
  },

  // 기존 수요조사 라우트 (일반 유저용)
  {
    path: "/buy/direct/step",
    name: "buy-direct-step",
    component: () => import("../views/buy/BuyDirectStepView.vue"),
  },
  {
    path: "/buy/direct/feedback",
    name: "buy-direct-feedback",
    component: () => import("../views/buy/BuyDirectFeedbackView.vue"),
  },

  // 직거래 MVP 라우트 (내부 테스터용)
  {
    path: "/buy/direct/list",
    name: "direct-deal-list",
    component: () => import("../views/buy/DirectDealListView.vue"),
  },
  {
    path: "/buy/direct/apply",
    component: () => import("../views/buy/DirectDealApplyView.vue"),
    children: [
      {
        path: "",
        name: "direct-deal-role",
        component: () => import("../components/direct/DirectDealRoleSelect.vue"),
      },
      {
        path: ":directDealSeq/verify",
        name: "direct-deal-verify",
        component: () => import("../components/direct/DirectDealIdentityVerify.vue"),
      },
      {
        path: ":directDealSeq/parties",
        name: "direct-deal-parties",
        component: () => import("../components/direct/DirectDealCoParties.vue"),
      },
      {
        path: ":directDealSeq/address",
        name: "direct-deal-address",
        component: () => import("../components/direct/DirectDealAddress.vue"),
      },
      {
        path: ":directDealSeq/transaction",
        name: "direct-deal-transaction",
        component: () => import("../components/direct/DirectDealTransaction.vue"),
      },
      // NZSC-3084 실험: 본인인증 제거. 계약자 본인 정보 직접입력 페이지
      {
        path: ":directDealSeq/my-info",
        name: "direct-deal-my-info",
        component: () => import("../components/direct/DirectDealMyInfo.vue"),
      },
      {
        path: ":directDealSeq/counterpart",
        name: "direct-deal-counterpart",
        component: () => import("../components/direct/DirectDealCounterpart.vue"),
      },
      {
        path: ":directDealSeq/confirm",
        name: "direct-deal-confirm",
        component: () => import("../components/direct/DirectDealConfirm.vue"),
      },
      {
        path: ":directDealSeq/waiting",
        name: "direct-deal-waiting",
        component: () => import("../components/direct/DirectDealWaiting.vue"),
      },
      {
        path: ":directDealSeq/guide",
        name: "direct-deal-guide",
        component: () => import("../components/direct/DirectDealGuide.vue"),
      },
      {
        path: ":directDealSeq/complete",
        name: "direct-deal-complete",
        component: () => import("../components/direct/DirectDealComplete.vue"),
      },
    ],
  },
  {
    path: "/buy/direct/consent/:directDealSeq/:partySeq",
    component: () => import("../views/buy/DirectDealConsentView.vue"),
    children: [
      {
        path: "",
        name: "direct-deal-consent",
        component: () => import("../components/direct/consent/DirectDealConsentLanding.vue"),
      },
      {
        path: "login",
        name: "direct-deal-consent-login",
        component: () => import("../components/direct/consent/DirectDealConsentLogin.vue"),
      },
      {
        path: "verify",
        name: "direct-deal-consent-verify",
        component: () => import("../components/direct/consent/DirectDealConsentVerify.vue"),
      },
      {
        path: "confirm",
        name: "direct-deal-consent-confirm",
        component: () => import("../components/direct/consent/DirectDealConsentConfirm.vue"),
      },
      {
        path: "complete",
        name: "direct-deal-consent-complete",
        component: () => import("../components/direct/consent/DirectDealConsentComplete.vue"),
      },
    ],
  },
];

export default buyRouter;
